export default "__VITE_ASSET__CAgHHwvy__"